module.exports = __webpack_public_path__ + "images/share036e7df5c5c2943f3fc8db7f24588032.svg";